import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Combobox } from "@/components/Combobox";
import { STATUS } from "@/lib/api";
import { LOTE_NONE_OPT } from "./loteHelpers";

/**
 * Cabeçalho "Aplicar a todas as linhas" do dialog de lote.
 * Contém apenas os campos globais: Data, Entregador e Status.
 * Tipo e Forma de Pagamento passaram a ser definidos por linha (fev/2026).
 */
export function LoteCommonHeader({ common, setCommon, entregadores }) {
  return (
    <div className="bg-orange-50/60 border border-orange-200 rounded-lg p-3">
      <div className="text-xs font-bold text-orange-800 uppercase mb-2">Aplicar a todas as linhas</div>
      <div className="grid md:grid-cols-3 gap-2">
        <div>
          <Label className="text-xs">Data</Label>
          <Input type="date" value={common.data} onChange={(e) => setCommon({ ...common, data: e.target.value })} data-testid="lote-data" />
        </div>
        <div>
          <Label className="text-xs">Entregador</Label>
          <Combobox
            options={entregadores}
            value={common.entregador_id || "__none__"}
            onChange={(v) => setCommon({ ...common, entregador_id: v === "__none__" ? "" : v })}
            placeholder="—"
            testId="lote-entregador"
            allowClear={false}
            noneOption={LOTE_NONE_OPT}
          />
        </div>
        <div>
          <Label className="text-xs">Status</Label>
          <Select value={common.status} onValueChange={(v) => setCommon({ ...common, status: v })}>
            <SelectTrigger data-testid="lote-status"><SelectValue /></SelectTrigger>
            <SelectContent>
              {Object.entries(STATUS).map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
